











































































import { Vue, Prop, Component } from 'vue-property-decorator';
import TextFieldAreaReadonlyInput from '@/shared/text-field/text-field-area-readonly-input.component.vue';
import TextFieldAreaBasicInput from '@/shared/text-field/text-field-area-basic-input.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ContractLink from '@/domain/contract/entity/contract-link.entity';

@Component({
  components: {
    TextFieldAreaReadonlyInput,
    TextFieldAreaBasicInput,
    MainButton,
    VbTooltipSlot,
  },
})
export default class ContractInfoModalNewInstance extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: false,
    default: () => ContractLink.of({}),
  })
  link!: ContractLink;

  $refs!: any;

  rules: Rules = new Rules();

  persistLink: ContractLink = ContractLink.of(this.link);

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  content(active: boolean) {
    return active ? 'Criar link' : 'Editar link';
  }

  saveLink(): void {
    this.sendEvent();
  }

  eventType(): string {
    if (this.link.isNew) return 'createLink';
    return 'updateLink';
  }

  sendEvent() {
    if (!this.$refs.form.validate()) {
      return;
    }
    this.$emit(this.eventType(), this.persistLink);
  }

  get title(): string {
    return this.link.isNew ? 'Criar' : 'Editar';
  }

  get saveButtonText(): string {
    return this.link.isNew ? 'Criar' : 'Editar';
  }
}
